/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetsInfo.vue?vue&type=template&id=b9dce842"
import script from "./assetsInfo.vue?vue&type=script&lang=js"
export * from "./assetsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports